import React, { useState, useEffect, useRef } from 'react';
import { SketchPicker, TwitterPicker } from 'react-color';
import { ColorPickerInputProps } from './Types';
import InputLabel from './InputLabel';
import Button from '../General/Button';
import { useTranslation } from 'react-i18next';

const ColorPickerInput = ({
  label,
  shape = 'squre',
  color = 'textPrimary',
  bg = 'white',
  onChange,
  name,
  required = false,
  value = '',
  size,
  disabled,
  colors,
  type = 'Sketch',
}: ColorPickerInputProps) => {
  const [showColors, setShowColors] = useState(false);
  const handleChange = (color: any) => {
    onChange(name, color.hex);
  };
  const ref = useRef<HTMLDivElement>(null);

  const { t } = useTranslation();
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setShowColors(false);
      }
    };
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [setShowColors]);

  const getPicker = () => {
    switch (type) {
      case 'Sketch':
        return (
          <SketchPicker
            color={value || ''}
            onChangeComplete={handleChange}
            className={`input focus:ring-opacity-0 mt-2 focus:ring-ring-color absolute z-50 ${
              size === 'med' && 'py-3'
            }  focus:ring-4 cursor-pointer   focus:ring-offset-0  ${
              shape === 'circle' ? 'rounded-full' : 'rounded-md'
            } bg-${bg} text-${color} focus:border-primary block w-full pe-14 sm:text-sm border-gray-300 `}
          />
        );
      case 'Twitter':
        return (
          <TwitterPicker
            color={value || ''}
            colors={colors}
            onChangeComplete={handleChange}
            triangle={'top-right'}
            width={'170px'}
            className={`input focus:ring-opacity-0 mt-4 focus:ring-ring-color absolute z-50 ${
              size === 'med' && 'py-1'
            }  focus:ring-4 cursor-pointer   focus:ring-offset-0  ${
              shape === 'circle' ? 'rounded-full' : 'rounded-md'
            } bg-${bg} text-${color} focus:border-primary block w-full  sm:text-sm border-gray-300 `}
          />
        );

      default:
        return null;
    }
  };
  return (
    <div>
      {label && <InputLabel text={label} name={name} required={required} />}
      <div
        className={`relative ${
          shape === 'circle' ? 'rounded-full' : 'rounded-md'
        } `}
      >
        <div className="flex space-s-2 align-middle w-auto border-none">
          <Button
            disabled={disabled}
            title="Pick Color"
            onClick={() => setShowColors(!showColors)}
          />{' '}
          {value && (
            <div
              style={{ backgroundColor: value }}
              className="w-8 h-8 rounded-full "
            ></div>
          )}
        </div>
        <div ref={ref}>{showColors && getPicker()}</div>
      </div>
    </div>
  );
};

export default ColorPickerInput;
